module.exports = __webpack_public_path__ + "static/media/3-admin-1.d771ae38.webp";